module.exports = __webpack_public_path__ + "img/cocos_4.a05a7348.jpg";